<template>
    <div>
        <transition name="show-from-left">
            <popover name="execution" :width="240">
                <Help :titleChart="title">
                    <div slot="content">
                        <p> {{ $t("280") }}</p>
                        <p> {{ $t("281") }}</p>
                        <p> {{ $t("282") }}</p>
                        <p> {{ $t("283") }}</p>
                        <br/>
                        <p>{{ $t("284") }}</p>
                    </div>
                </Help>
            </popover>
        </transition>

        <div class="title-charts">{{ title }}
            <button class="bt-help" v-popover:execution.right><i class="icon-help ti-help-alt"></i></button>
        </div>

        <!-- Indicator widget -->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <indicator-widget  v-bind:legend="$t('285')" v-bind:color="total_falhas_cor" v-bind:valall="total_falhas_all" v-bind:val1y="total_falhas_y" v-bind:val6m="total_falhas_6m"></indicator-widget>
                </div>
                <div class="col-md-4">
                    <indicator-widget  v-bind:legend="$t('286')" v-bind:color="total_resolvidos_cor" v-bind:valall="total_resolvidos_all" v-bind:val1y="total_resolvidos_y" v-bind:val6m="total_resolvidos_6m"></indicator-widget>
                </div>
                <div class="col-md-4">
                    <indicator-widget  v-bind:legend="$t('287')" v-bind:color="total_media_cor" v-bind:valall="total_media_all" v-bind:val1y="total_media_y" v-bind:val6m="total_media_6m"></indicator-widget>
                </div>
            </div>
        </div>

        <!-- History Charts -->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <history-chart id="chart_failure" v-bind:typeValue="'DR'" v-bind:header="$t('253')" v-bind:data="chart_failure_data"></history-chart>
                </div>
                <div class="col-md-4">
                    <history-chart id="chart_resolved" v-bind:typeValue="'Feedback'" v-bind:header="$t('254')" v-bind:data="chart_resolved_data"></history-chart>
                </div>
                <div class="col-md-4">
                    <history-chart id="chart_tmsa" v-bind:typeValue="'Days'" v-bind:header="$t('255')" v-bind:data="chart_tmsa_data"></history-chart>
                </div>
            </div>
        </div>

        <transition name="show-from-left">
            <popover name="radar" :width="240">
                <Help :titleChart="title2">
                    <div slot="content">
                        <p>{{ $t("288") }}</p>
                    </div>
                </Help>
            </popover>
        </transition>

        <div class="title-charts">{{ title2 }}
            <button class="bt-help" v-popover:radar.right><i class="icon-help ti-help-alt"></i></button>
        </div>

        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4" v-for="(item, key, index) in radar_data" :key="index">
                    <area-radar-chart v-bind:header="key" v-bind:data="item.data" v-bind:categories="item.categories" v-bind:id="'radar_'+index" :filters='filters'></area-radar-chart>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios';
import mixin from '../../../../utils/mixin'
import IndicatorWidget from '../Components/Indicator-Widget'
import HistoryChart from '../Components/History-chart'
import AreaRadarChart from '../Charts/Area-radar-chart'
import Help from 'src/components/Dashboard/Views/components/Help'

import $ from 'jquery';

const API = process.env.ROOT_API;

export default {
    components: {
        IndicatorWidget,
        HistoryChart,
        Help,
        AreaRadarChart
    },
    data() {
        return {
            title: this.$t("289"),
            title2: this.$t("290"),
            total_falhas_all: 0,
            total_resolvidos_all: 0,
            total_media_all: 0,
            total_falhas_y: 0,
            total_resolvidos_y: 0,
            total_media_y: 0,
            total_falhas_6m: 0,
            total_resolvidos_6m: 0,
            total_media_6m: 0,
            total_falhas_cor: 'red',
            total_resolvidos_cor: 'green',
            total_media_cor: 'blue',
            chart_failure_data: [],
            chart_resolved_data: [],
            chart_tmsa_data: [],
            radar_data: [],
            last_region: '',
            last_plant: -1,
            last_area: '',
            last_sector: '',
            last_machine: '',
            last_component: '',
            last_technique: '',
        }
    },
    mixins: [mixin],
    methods: {
        getReportsOnline() {
            var self = this
            var param = {"plant_id": this.filters.plant, "technique_id": this.filters.technique, "corp": 1, "region": this.filters.region, "area": this.filters.area, "sector": this.filters.sector, "sector": this.filters.sector, "machine": this.filters.machine, "component": this.filters.component};
            //param = $.param(param);

            axios({method: 'GET', url: API + 'v1/mysemeq-ambev/history-reports', params: param, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(function(response){
                self.total_falhas_all = 0;
                self.total_media_all = 0;
                self.total_falhas_y = 0;
                self.total_media_y = 0;
                self.total_falhas_6m = 0;
                self.total_media_6m = 0;
                var data = response.data;
                var data_len = data.length;
                var last_12_month = data_len-13;
                var last_6_month = data_len-7;
                self.chart_failure_data = [];
                self.chart_tmsa_data = [];
                var i=0;

                $.each( data, function( key, val ) {
                    self.total_falhas_all += val.total;
                    self.total_media_all += val.average;
                    self.chart_failure_data.push([val.ref_date, val.total]);
                    self.chart_tmsa_data.push([val.ref_date, val.average]);

                    if(i>=last_12_month){
                        self.total_falhas_y += val.total;
                        self.total_media_y += val.average;
                    }

                    if(i>=last_6_month){
                        self.total_falhas_6m += val.total;
                        self.total_media_6m += val.average;
                    }
                    i++;
                });

                self.total_media_all = parseFloat((self.total_media_all/i).toFixed(1));
                self.total_media_y = parseFloat((self.total_media_y/12).toFixed(1));
                self.total_media_6m = parseFloat((self.total_media_6m/6).toFixed(1));

            }).catch(function (response){
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
        getReportsRci(){

            let self = this
            let param = {"plant_id": this.filters.plant, "technique_id": this.filters.technique, "corp": 1, "region": this.filters.region, "area": this.filters.area, "sector": this.filters.sector, "sector": this.filters.sector, "machine": this.filters.machine, "component": this.filters.component};

            axios({method: 'GET', url: API + 'v1/mysemeq-ambev/history-reports-rci', params: param, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(function(response){
                self.total_resolvidos_all = 0;
                self.total_resolvidos_y = 0;
                self.total_resolvidos_6m = 0;
                let data = response.data;
                let data_len = data.length;
                let last_12_month = data_len-13;
                let last_6_month = data_len-7;
                self.chart_resolved_data = [];
                let i=0;

                $.each( data, function( key, val ) {
                    self.total_resolvidos_all += val.total;
                    self.chart_resolved_data.push([val.ref_date, val.total]);

                    if(i>=last_12_month){
                        self.total_resolvidos_y += val.total;
                    }

                    if(i>=last_6_month){
                        self.total_resolvidos_6m += val.total;
                    }

                    i++;
                });

            }).catch(function (response){
                self.ApiErrorHandler(self, error.response.data.status_code);
            });

        },
        getAreaReports(){

            let self = this;

            let param = {"plant_id": this.filters.plant, "technique_id": this.filters.technique, "corp": 1, "region": this.filters.region, "year": this.filters.year, "period": this.filters.period, "area": this.filters.area, "sector": this.filters.sector, "sector": this.filters.sector, "machine": this.filters.machine, "component": this.filters.component};

            axios({method: 'GET', url: API + 'v1/mysemeq-ambev/areas-reports', params: param, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
            .then(function(response){

                let data = response.data;
                let new_data = {};
                let area = '';

                let count = 0; // pega somente os 10 primeiros
                $.each( data, function( key, val ) {
                    if(val.total>=1){
                        if(area != val.area){
                            new_data[val.area] = {data: [], categories: []};
                            area = val.area;
                            count = 0
                        }

                        if (count < 10) {
                            new_data[val.area].data.push(val.total);
                            new_data[val.area].categories.push(val.sector);
                        }

                        count += 1
                    }
                });

                self.radar_data = new_data;

            }).catch(function (response){
                self.ApiErrorHandler(self, error.response.data.status_code);
            });
        },
    },
    computed: {
        ...mapGetters(['filters']),
    },
    watch: {
        filters: function(newValue){
            this.getAreaReports();

            if (this.last_region != newValue.region || this.last_plant != newValue.plant || this.last_area != newValue.area || this.last_sector != newValue.sector  || this.last_machine != newValue.machine || this.last_component != newValue.component || this.last_technique != newValue.technique) {
                this.getReportsOnline();
                this.getReportsRci();
            }

            this.last_region = newValue.region;
            this.last_plant = newValue.plant;
            this.last_area = newValue.area;
            this.last_sector = newValue.sector;
            this.last_machine = newValue.machine;
            this.last_component = newValue.component;
            this.last_technique = newValue.technique;
        },
    }
}
</script>

<style scoped>
.title-charts{
    margin-bottom: 20px;
}
div[data-popover="execution"] {
  left: 57% !important;
  top: 0% !important;
}
div[data-popover="radar"] {
  left: 60% !important;
  top: 345px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Components/ExecutionIndicators.vue